import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Use existing Auth component which handles login/register
import Auth from '../screens/Auth';

const AuthRoutes: React.FC = () => {
    return (
        <Routes>
            {/* All auth routes use the same Auth component which handles login/register toggle */}
            <Route path="login" element={<Auth />} />
            <Route path="register" element={<Auth />} />

            {/* Default redirect to login */}
            <Route path="" element={<Navigate to="login" replace />} />
            <Route path="*" element={<Navigate to="login" replace />} />
        </Routes>
    );
};

export default AuthRoutes; 